export const invalidateDates = (actionContext: $TSFixMe, { sessionId, message }: $TSFixMe, done: $TSFixMe) => {
  actionContext.dispatch('INVALIDATE_DATES', { sessionId, message });
};

export const validateDates = (actionContext: $TSFixMe, { sessionId }: $TSFixMe, done: $TSFixMe) => {
  actionContext.dispatch('VALIDATE_DATES', { sessionId });
};
